module.exports = __webpack_public_path__ + "static/media/IS-FOUR.7b661e5b.png";